import { classNames, zodiacBetArr, calcMantissa } from "../../../../../tool";
import Number from "../../../../../components/number";
import styles from "../index.module.scss";

// 尾数、一肖
export default function PTYXWS(props) {
  const { plays, selectPlays, onBet, playOddInfo, firstPlay, secondPlay } =
    props;
  return (
    <div className={styles.playContainer}>
      {plays.map((item, index) => {
        const active =
          selectPlays.findIndex((i) => i.code === item.code) !== -1;
        const betArr =
          firstPlay.name === "连尾" || firstPlay.name === "尾数"
            ? calcMantissa(index, 49)
            : zodiacBetArr[index];
        return (
          <div
            key={index}
            className={classNames(
              styles.PTYXWS,
              styles.playItem,
              active ? styles.active : ""
            )}
            onClick={() => onBet(item)}
          >
            <div className={styles.leftName}>
              <div className={styles.name}>{item.name}</div>
              <div className={styles.odds}>
                {
                  playOddInfo[
                    `LHC_${firstPlay.code}_${
                      secondPlay.code || firstPlay.code
                    }${item.code}${
                      zodiacBetArr[index].length > 4 &&
                      firstPlay.name === "一肖"
                        ? "0"
                        : ""
                    }`
                  ]
                }
              </div>
            </div>
            <div className={styles.rightNumber}>
              {betArr.map((it, idx) => {
                return (
                  <Number
                    key={idx}
                    number={it}
                    width={"7.556rem"}
                    height={"7.556rem"}
                    fontSize={"3.551rem"}
                    active={active}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
